import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ShippingTermsDropDownDto } from './shipping-terms-drop-down.dto';


export class ShippingTermsDropDownResponseModel extends GlobalResponseObject {
    data?: ShippingTermsDropDownDto[];
    
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: ShippingTermsDropDownDto[]){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

